export default function IndexPage() {
  return <></>;
}
